import React from "react";
import ReactDOM from "react-dom";
import { initTheme } from "./theme/theme";
import { installGlobalModalDrag } from "./utils/globalModalDrag";   // tog'a #2026: barcha modal oynalar sudraladi
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "./services/i18n";
import { Suspense } from "react";
import Preloader from "./containers/spinners/Preloader";
import { HelmetProvider } from "react-helmet-async";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ApolloProvider } from "@apollo/client";
import client from "./services/apollo";
import { installFormErrorScroll } from "./utils/formErrorScroll";   // tog'a #276

installGlobalModalDrag();   // tog‘a #2026: barcha modal oynalar sarlavhasidan sudraladi (sichqoncha + barmoq)
installFormErrorScroll();   // tog'a #276: formada xato bo'lsa — birinchi xatoli maydonga surish + qaysi maydonlar

// Deploy'dan keyin eski keshlangan main.js serverda yo'q lazy-chunk'larni so'rasa
// (ChunkLoadError), sahifa jimgina sinardi ("Добавить bosilmayabdi" holati) —
// bunday xatoda sahifani avtomatik bir marta yangilaymiz (10s ichida takror emas)
function reloadOnChunkError() {
  try {
    const last = Number(sessionStorage.getItem("chunk_reload_ts") || 0);
    if (Date.now() - last < 10000) return;
    sessionStorage.setItem("chunk_reload_ts", String(Date.now()));
  } catch {}
  window.location.reload();
}
const isChunkError = (msg: string) =>
  /Loading chunk [\w-]+ failed|ChunkLoadError|Loading CSS chunk/i.test(msg || "");
window.addEventListener(
  "error",
  (e: any) => {
    if (isChunkError(e?.message || "") || isChunkError(String(e?.error?.message || ""))) reloadOnChunkError();
  },
  true
);
window.addEventListener("unhandledrejection", (e: any) => {
  const m = String(e?.reason?.message || e?.reason || "");
  if (isChunkError(m)) reloadOnChunkError();
});

const queryClient = new QueryClient({defaultOptions: {
  queries: {refetchOnWindowFocus: false,}
}})
// Tog'a #342 (katalog #6024, «Авто-обновление»): muvaffaqiyatli yozuvdan keyin (utils/config «crm-write-ok») ekrandagi FAOL ro'yxatlar
// qayta olinadi — ketma-ket yozuvlar bitta yangilanishga yig'iladi (600 ms). Faol bo'lmagan keshlar keyingi ochilishda yangilanadi.
let avtoYangilash: any = null;
window.addEventListener("crm-write-ok", () => {
  clearTimeout(avtoYangilash);
  avtoYangilash = setTimeout(() => { queryClient.invalidateQueries({ refetchType: "active" }).catch(() => {}); }, 600);
});
// import * as serviceWorker from "./serviceWorker";

// Ilgari ro'yxatdan o'tgan legacy cache-first service worker (public/worker.js)
// eski index.html'ni keshdan berib, deploy'dan keyin "chunk topilmadi" xatosiga
// sabab bo'lardi — barcha eski registratsiya va kesh'larni tozalaymiz.
try {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {})
  }
  if (window.caches) {
    caches.delete("pwa-task-manager").catch(() => {})
  }
} catch {
  // eski brauzerlarda API bo'lmasa ham ilova ishlashda davom etadi
}
// Dark mode ilova chizilishidan OLDIN qo'llanadi — oq "chaqnash" bo'lmasin
initTheme();

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Preloader />}>
        <QueryClientProvider client={queryClient}>
      <ApolloProvider client={client}>
        <I18nextProvider i18n={i18n}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </I18nextProvider>
      </ApolloProvider>
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
